import { apiMedications } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'medications';

const config = [
  { actionType: 'getAll', apiPath: apiMedications, method: get, actionParams: { limit: 0 } },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiMedications}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
